/* Notificari "cineva a comandat" — DATE REALE, fara nume (3 aug 2026).
   Sursa: assets/neclintit-comenzi.json, regenerat zilnic de sync-daily.sh.
   Fara aplicatie, fara JS strain, fara cereri catre alt domeniu.
   Comportament aliniat cu aplicatia de pe WARGEAR (3 aug): inchiderea tine
   1 ORA (nu doar sesiunea), iar cronometrul se opreste cat timp mouse-ul
   sta pe notificare. */
(function () {
  var CFG = window.NC_COMENZI || {};
  var PRIMA = (CFG.prima || 10) * 1000;      // pana la prima notificare
  var INTRE = (CFG.intre || 120) * 1000;     // pauza intre notificari
  var VIZIBIL = (CFG.vizibil || 10) * 1000;  // cat sta pe ecran
  var MAX = CFG.max || 10;                   // cate pe vizita
  var ORA = 3600 * 1000;                     // cat tine inchiderea

  if (!CFG.activ) return;
  try {
    var pana = parseInt(localStorage.getItem('nc-comenzi-inchis') || '0', 10);
    if (pana && Date.now() < pana) return;
  } catch (e) {}
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) VIZIBIL = Math.max(VIZIBIL, 9000);

  var date = null, idx = 0, aratate = 0, el = null, tmr = null, peste = false, asteapta = null;

  function ago(ore) {
    if (ore < 2) return 'acum câteva momente';
    if (ore < 6) return 'acum câteva ore';
    if (ore < 24) return 'astăzi';
    if (ore < 48) return 'ieri';
    if (ore < 24 * 7) return 'acum câteva zile';
    return 'săptămâna trecută';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function construieste() {
    el = document.createElement('div');
    el.className = 'nc-comanda';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    // cat timp mouse-ul e pe notificare, nu o ascundem (ca la WARGEAR)
    el.addEventListener('mouseenter', function () { peste = true; clearTimeout(tmr); });
    el.addEventListener('mouseleave', function () {
      peste = false;
      if (asteapta === 'ascunde') tmr = setTimeout(function () { ascunde(); programeaza(); }, 1200);
    });
    document.body.appendChild(el);
  }
  function ascunde() { if (el) el.classList.remove('nc-comanda--vizibil'); asteapta = null; }
  function inchideDeTot() {
    ascunde();
    clearTimeout(tmr);
    try { localStorage.setItem('nc-comenzi-inchis', String(Date.now() + ORA)); } catch (e) {}
  }
  function programeaza() { if (aratate < MAX) tmr = setTimeout(arata, INTRE); }
  function arata() {
    if (!date || !date.length || aratate >= MAX) return;
    var c = date[idx % date.length]; idx++; aratate++;
    var ore = c.ts ? Math.max(1, Math.round((Date.now() - new Date(c.ts).getTime()) / 36e5)) : c.ore;
    el.innerHTML =
      '<a class="nc-comanda__link" href="/products/' + esc(c.handle) + '">' +
        '<img class="nc-comanda__poza" src="' + esc(c.poza) + '" alt="" width="52" height="52" loading="lazy">' +
        '<span class="nc-comanda__text">' +
          '<span class="nc-comanda__sus">Cineva din ' + esc(c.oras) + ' a comandat</span>' +
          '<span class="nc-comanda__titlu">' + esc(c.titlu) + '</span>' +
          '<span class="nc-comanda__jos">' + (CFG.fara_timp ? '' : esc(ago(ore)) + ' &middot; ') + 'comandă verificată</span>' +
        '</span>' +
      '</a>' +
      '<button class="nc-comanda__x" type="button" aria-label="Închide">&times;</button>';
    el.querySelector('.nc-comanda__x').addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); inchideDeTot(); });
    el.classList.add('nc-comanda--vizibil');
    asteapta = 'ascunde';
    tmr = setTimeout(function () {
      if (peste) return;             // mouse-ul e pe ea -> asteptam sa plece
      ascunde(); programeaza();
    }, VIZIBIL);
  }
  function porneste() {
    fetch(CFG.url, { cache: 'no-cache' }).then(function (r) { return r.json(); }).then(function (j) {
      date = (j && j.comenzi || []).filter(function (c) { return c && c.oras && c.titlu && c.handle; });
      if (date.length < 3) return;   // prea putine -> nu aratam nimic
      construieste();
      tmr = setTimeout(arata, PRIMA);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
